<template>
  <div style="margin: -15px -15px; background-color: #f0f2f5">
    <!-- tag查询框 -->
    <div class="datePicker">
      <div class="date">
        标题：
        <a-input
          style="width: 180px; margin-right: 20px"
          placeholder="请输入"
          v-model="searchName"
          @keyup.enter="searchBtn"
        ></a-input>
      </div>
      <div>
        内容类型: &nbsp;
        <!-- v-model="searchType" -->
        <a-select placeholder="请选择" v-model="selectType" style="width:150px" @change="typeChange">
         <a-select-option v-for="type in stateTypeList" :value="type.state">
           {{ type.title }}
         </a-select-option>
        </a-select>
      </div>
      <div style="margin-left: 20px;">
        分类: &nbsp;
        <!-- v-model="searchType" -->
        <a-select placeholder="请选择" v-model="FLType" style="width:150px" @change="typeChange">
           <a-select-option value="">
            全部
           </a-select-option>
           <a-select-option v-for="type in messageType" :value="type">
             {{ type }}
           </a-select-option>
        </a-select>
      </div>
      <div style="margin-left: 20px;">
        范围: &nbsp;
        <a-radio-group  v-model="Ftype" style="margin-right: 40px" @change="searchOk">
          <a-radio-button value="">
            全部
          </a-radio-button>
          <a-radio-button value="mina">
            小程序
          </a-radio-button>
          <a-radio-button value="app">
           APP
          </a-radio-button>
          <a-radio-button value="web">
           官网
          </a-radio-button>
        </a-radio-group>
      </div>
      <!-- <div style="margin-left: 20px;">
        分类: &nbsp;
        <a-radio-group  v-model="FLType" style="margin-right: 40px" @change="searchOk">
          <a-radio-button value="">
            全部
          </a-radio-button>
          <a-radio-button value="系统通知">
            系统通知
          </a-radio-button>
          <a-radio-button value="功能上新">
            功能上新
          </a-radio-button>
          <a-radio-button value="内容更新">
            内容更新
          </a-radio-button>
        </a-radio-group>
      </div> -->
      <div>
        <a-button @click="selectBtn" type="primary" style="margin-left: 40px"
          >查询</a-button
        >
        <a-button @click="restBtn" style="margin-left: 10px"
          >重置</a-button
        >
      </div>
    </div>

    <div style="background-color: #fff; padding: 20px; padding-bottom: 80px">
      <a-button
        type="primary"
        style="margin-bottom: 20px; margin-right: 3%"
        @click="newlyBuilt"
      >
        新增
      </a-button>
      <a-table
        :columns="columns"
        style="min-height: 500px; background-color: #fff"
        :data-source="HeplTable"
        :rowKey="(record) => record.id"
        :pagination="false"
      >
        <span slot="operate" slot-scope="text, item, index">
          <a style="margin-right: 10px" @click="openPush(item)">查看明细</a>
          <a @click="editBtn(item)" style="margin-right: 10px">编辑</a>
          <a-popconfirm
            title="确定删除?"
            ok-text="是"
            cancel-text="否"
            @confirm="delBtn(item.id)"
          >
            <!-- @cancel="cancel" -->
            <a style="margin-right: 10px">删除</a>
          </a-popconfirm>
        </span>
        <span slot="theTitle" slot-scope="text, item,record" >
          <!-- 悬浮框 -->
          <a-tooltip placement="topLeft">
            <template slot="title">
              {{ text }}
            </template>
            <!-- 内容 -->
            <div class="multi-ellipsis"  id="multi-ellipsis"> <span class="span"> {{ text }}</span></div>
          </a-tooltip>
        </span>
        <span slot="theContent" slot-scope="text, item,record" >
          <!-- 悬浮框 -->
          <a-tooltip placement="topLeft">
            <span slot="title" v-html="text">

            </span>
            <!-- 内容 -->
            <div class="multi-ellipsis" v-if="item.type == 'text'"  id="multi-ellipsis"> <span class="span" v-html="text"> </span></div>
          </a-tooltip>
          <a v-if="item.type == 'image'" @click="viewImage(item)">
            查看
          </a>
        </span>
        <span slot="channelsString" slot-scope="text, item,record" >
          <!-- 悬浮框 -->
          <span v-if="item.isSuportLink === 1">
            {{ text }}
          </span>
          <span v-else>
           -
          </span>
           <!-- <span>
            {{ item.isSuportLink }}
           </span> -->
        </span>
        <span slot="type" slot-scope="text, record, item, id">
          <span v-if="text == 'image'">图片</span>
          <span v-if="text == 'text'">文字</span>
        </span>
        <span slot="mark" slot-scope="text, record, item, id">
          <!-- 置顶 -->
          <a-switch
            @change="open2Change(record, record.isOpen === 1 ? 0 : 1)"
            :checked="record.isOpen !== 0"
            checked-children="开"
            un-checked-children="关"
            default-checked
          />
        </span>
        <span slot="isPush" slot-scope="text, record, item, id">
          <!-- 置顶 -->
          <a-switch
            @change="openChange(record, record.isPush === 1 ? 0 : 1)"
            :checked="record.isPush !== 0"
            checked-children="开"
            un-checked-children="关"
            default-checked
          />
        </span>
      </a-table>
      <!-- table框的分页 -->
      <div
        style="
          margin-top: 28px;
          display: flex;
          align-items: center;
          justify-content: space-between;
        "
      >
        <span
          style="font-size: medium; color: #929292; font-size: 14px; bottom: 3%"
        >
          共{{ pagination.total }}条记录 第 {{ pagination.pageNum }} /
          {{ Math.ceil(pagination.total / pagination.pageSize) }} 页
        </span>
        <a-pagination
          style="float: right"
          show-quick-jumper
          show-size-changer
          :page-size.sync="pagination.pageSize"
          :total="pagination.total"
          v-model="pagination.current"
          @change="pageChange"
          @showSizeChange="pageChange"
        />
      </div>
    </div>

    <!-- 新建的表单 -->
    <a-drawer
      title="新增/修改"
      placement="right"
      :closable="false"
      :visible="addShow"
      @close="addCancel"
      width="40%"
    >
      <a-form-model
          :model="addForm"
          :label-col="labelCol"
          :rules="rules"
          :wrapper-col="wrapperCol"
          ref="add"
      >
       <a-form-model-item label="消息类型" prop="messageType">
         <a-select
            v-model="addForm.messageType"
            placeholder="请选择"
            show-search
          >
            <a-select-option
              v-for="item in messageType"
              :value="item"
              :key="item"
            >
              {{ item }}
            </a-select-option>
         </a-select>
       </a-form-model-item>
       <a-form-model-item label="标题" prop="title">
         <a-input v-model="addForm.title" placeholder="请输入" />
       </a-form-model-item>
       <a-form-model-item label="内容类型" prop="type">
         <a-radio-group name="radioGroup" v-model="addForm.type">
           <a-radio value="text">
             文本
           </a-radio>
           <a-radio value="image">
             图片
           </a-radio>
         </a-radio-group>
       </a-form-model-item>
       <!-- <a-form-model-item label="文本" required v-if="addForm.type === 'text'">
         <a-input v-model="addForm.content" placeholder="请输入" />
       </a-form-model-item> -->
       <a-form-model-item required label="文本" v-if="addForm.type === 'text'">
         <div
           style="border: 1px solid #ccc; min-height: 300px; width: 400px"
         >
           <Toolbar
             style="border-bottom: 1px solid #ccc"
             :editor="editor"
             :defaultConfig="toolbarConfig"
             :mode="mode"
           />
           <Editor
             style="overflow-y: hidden"
             v-model="html"
             :defaultConfig="editorConfig"
             :mode="mode"
             @onCreated="onCreated"
           />
         </div>
       </a-form-model-item>




       <a-form-model-item label="上传图片"  required v-if="addForm.type === 'image'">
         <div
           style="
             display: flex;
             flex-wrap: wrap;
             justify-content: space-between;
             width: 100%;
           "
         >
           <div class="uploadImg2">
            +
             <input
               style="
                 position: absolute;
                 cursor: pointer;
                 width: 330px;
                 height: 190px;
                 opacity: 0;
                 top: 0;
                 left: 0;
                 z-index: 1;
               "
               accept="image/*"
               type="file"
               @change="manageUploadIcon"
               ref="manageIcon"
               id="manageLibrary"
             />
           </div>
           <div class="upload_image2">
             <img
               alt=""
               v-if="addForm.content"
               style="width: 330px; height: 190px;position: absolute;top:0;left:0;"
               :src="addForm.content"
             />
           </div>
         </div>
       </a-form-model-item>
       <a-form-model-item label="是否支持跳转" prop="isSuportLink">
         <a-switch
          :checked="addForm.isSuportLink !== 0" @click="noticeEdit(addForm.isSuportLink === 1? 0 : 1)"
          checked-children="是" un-checked-children="否"  />
       </a-form-model-item>
       <a-form-model-item label="推送范围" prop="channels">
         <a-checkbox-group @change="onChange" v-model="addForm.channels">
           <a-row>
             <a-col :span="24">
               <div style="display: flex;align-items: center;">
                 <a-checkbox value="mina" style="width: 200px;">
                  小程序
                 </a-checkbox>
                 <a-input v-if="addForm.channels.includes('mina')" v-model="addForm.minaLink" placeholder="请输入跳转地址" />
               </div>
             </a-col>
             <a-col :span="24">
               <div style="display: flex;align-items: center;margin-top: 20px;">
                 <a-checkbox value="app" style="width: 200px;">
                  APP
                 </a-checkbox>
                 <a-input v-model="addForm.appLink"  v-if="addForm.channels.includes('app')"  placeholder="请输入跳转地址" />
               </div>
             </a-col>
             <a-col :span="24">
               <div style="display: flex;align-items: center;margin-top: 20px;">
                 <a-checkbox value="web" style="width: 200px;">
                  官网
                 </a-checkbox>
                 <a-input v-model="addForm.webLink" v-if="addForm.channels.includes('web')"  placeholder="请输入跳转地址" />
               </div>
             </a-col>
           </a-row>
         </a-checkbox-group>
       </a-form-model-item>
      </a-form-model>

      <div
          :style="{
            position: 'absolute',
            right: 0,
            bottom: 0,
            width: '100%',
            borderTop: '1px solid #e9e9e9',
            padding: '10px 16px',
            background: '#fff',
            textAlign: 'right',
            zIndex: 1,
          }"
        >
          <a-button
            :style="{ marginRight: '8px' }"
            @click="
              () => {
                this.addShow = false;
                this.$refs.add.resetFields();
                this.addForm = {channels:[],isSuportLink:0}
              }
            "
          >
            取消
          </a-button>
          <a-button
            :style="{ marginRight: '8px' }"
            type="primary"
            @click="addOk()"
          >
            确定
          </a-button>
      </div>
    </a-drawer>
    <a-modal v-model="modalOpen" title="推送图片" :footer="null">
       <div style="width: 500px;min-height: 400px;">
         <img :src="thisContent" alt="" style="width: 90%;">
       </div>
    </a-modal>

    <a-drawer
      title="推送明细"
      placement="right"
      :closable="false"
      :visible="PushShow"
      @close="PushCancel"
      width="80%"
    >

      <a-table
        :columns="Pushcolumns"
        style="min-height: 500px; background-color: #fff"
        :data-source="PushTable"
        :rowKey="(record) => record.id"
        :pagination="false"
      >
        <template slot="theisClick" slot-scope="text, item,record">
          <span v-if="text === 1">已点击</span>
          <span v-else>否</span>
        </template>
      </a-table>
      <!-- table框的分页 -->
      <div
        style="
          margin-top: 28px;
          display: flex;
          align-items: center;
          justify-content: space-between;
        "
      >
        <span
          style="font-size: medium; color: #929292; font-size: 14px; bottom: 3%"
        >
          共{{ pagiDnation.total }}条记录 第 {{ pagiDnation.pageNum }} /
          {{ Math.ceil(pagiDnation.total / pagiDnation.pageSize) }} 页
        </span>
        <a-pagination
          style="float: right"
          show-quick-jumper
          show-size-changer
          :page-size.sync="pagiDnation.pageSize"
          :total="pagiDnation.total"
          v-model="pagiDnation.current"
          @change="pageChange"
          @showSizeChange="pageChange"
        />
      </div>
    </a-drawer>
  </div>
</template>

<script>
import {
  getMessage,postMessage,putMessage,delMessage,getReceive
} from "@/service/MessagePush";
import axios from "axios";
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import E from "wangeditor";
import {
  getSelect
} from "@/service/Recruiting";
import { update ,update_New} from "@/utils/update";
const editorConfig = {
  // JS 语法
  MENU_CONF: {},
};
const signature = "";
// 修改 uploadImage 菜单配置
editorConfig.MENU_CONF["uploadImage"] = {
  // 自定义上传
  async customUpload(file, insertFn) {
    let formData = new FormData();
    formData.append("file", file);
    // file 即选中的文件,自己实现上传，并得到图片 url alt href
    axios
      .post(
        "https://yun-new-admin-api.yunicu.com/api/admin/common/update",
        formData
      )
      .then((res) => {
        if (res.data.code === 0) {
          insertFn(res.data.data.url); // 最后插入图片
        }
      });
  },
};
// 修改 uploadVideo 菜单配置
editorConfig.MENU_CONF["uploadVideo"] = {
  // 自定义上传
  async customUpload(file, insertFn) {
    let mediaFile = file;
    //获取签名
    axios
      .get("https://yun-new-admin-api.yunicu.com/v3/getUgcUploadSign")
      .then((res) => {
        if (res.data.code === 0) {
          const getSignature = () => {
            return res.data.data.signature;
          };
          const tcVod = new TcVod({
            getSignature: getSignature, //上传签名的函数
          });
          const uploader = tcVod.upload({
            mediaFile: mediaFile, // 媒体文件（视频或音频或图片），类型为 File
          });
          uploader.done().then((res) => {
            insertFn(res.video.url); // 进行视频处理：转码和截图
          });
        }
      });
  },
};
export default {
    data() {
        return {
            editor: null,
            html: "",
            toolbarConfig: {},
            editorConfig,
            mode: "default", // or 'simple'
            PushTable:[],
            PushShow:false,
            searchName: '',
            thisContent:'',
            addForm:{channels:[],isSuportLink:0},
            messageType:[],
            pagination: {
              //存储大table的分页
              total: 0,
              current: 1,
              pageSize: 10,
              pageNum: 1,
            },
            FLType:"",
            pagiDnation: {
              //存储大table的分页
              total: 0,
              current: 1,
              pageSize: 10,
              pageNum: 1,
            },
            labelCol: { span: 5 },
            wrapperCol: { span: 18 },
            rules: {
              messageType: [{ required: true, message: "请选择", trigger: "change" }],
              title: [{ required: true, message: "请输入", trigger: "blur" }],
              type: [{ required: true, message: "请选择", trigger: "change" }],
              channels: [{ required: true, message: "请选择", trigger: "change" }],
              // content: [{ required: true, message: "请输入", trigger: "blur" }],
              isSuportLink: [{ required: true, message: "请选择", trigger: "change" }],
            },
            HeplTable: [],
            stateTypeList: [  //用于紧急程度选择框
              {
                title: '全部',
                state: ''
              }, 
              {
                title: '文字',
                state: 'text'
              }, {
                title: '图片',
                state: 'image'
              }
            ],
            selectType:'',
            Ftype:'',
            addShow:false,
            buttonType:'',
            modalOpen:false,
            pushMessageId:'',
            Pushcolumns:[
              {
                title: "接收人IP地址",
                dataIndex: "ip",
                key: "ip",
                //    align:'center',
                width:160,
                // scopedSlots: { customRender: "theTitle" },
              },
              {
                title: "姓名",
                dataIndex: "name",
                key: "name",
                //    align:'center',
                // width:200,
                // scopedSlots: { customRender: "theTitle" },
              },
              {
                title: "医院",
                dataIndex: "hospitalName",
                key: "hospitalName",
                //    align:'center',
                width:200,
                // scopedSlots: { customRender: "theTitle" },
              },
              {
                title: "手机号",
                dataIndex: "tel",
                key: "tel",
                //    align:'center',
                // width:200,
                // scopedSlots: { customRender: "theTitle" },
              },
              {
                title: "身份",
                dataIndex: "typeString",
                key: "typeString",
                //    align:'center',
                // width:200,
                // scopedSlots: { customRender: "theTitle" },
              },
              {
                title: "接受时间",
                dataIndex: "createdTime",
                key: "createdTime",
                //    align:'center',
                // width:200,
                // scopedSlots: { customRender: "theTitle" },
              },
              {
                title: "接受渠道",
                dataIndex: "channel",
                key: "channel",
                //    align:'center',
                // width:200,
                // scopedSlots: { customRender: "theTitle" },
              },
              {
                title: "是否点击",
                dataIndex: "isClick",
                key: "isClick",
                //    align:'center',
                // width:200,
                scopedSlots: { customRender: "theisClick" },
              },
              {
                title: "点击时间",
                dataIndex: "clickCreatedTime",
                key: "clickCreatedTime",
                //    align:'center',
                // width:200,
                // scopedSlots: { customRender: "theTitle" },
              },
            ],
            columns: [
              {
                title: "推送标题",
                dataIndex: "title",
                key: "title",
                //    align:'center',
                width:200,
                scopedSlots: { customRender: "theTitle" },
              },
              {
                title: "内容类型",
                dataIndex: "type",
                key: "type",
                // align: "center",
                scopedSlots: { customRender: "type" },
              },
              {
                title: "推送内容",
                dataIndex: "content",
                key: "content",
                align: "center",
                width:220,
                scopedSlots: { customRender: "theContent" },
              },
              {
                title: "推送范围",
                dataIndex: "channelsString",
                key: "channelsString",
                align: "center",
                //scopedSlots: { customRender: "channelsString" },
              },
              {
                title: "创建时间",
                dataIndex: "createdTime",
                key: "createdTime",
                align: "center",
                // scopedSlots: { customRender: "addTime" },
              },
              {
                title: "是否推送",
                dataIndex: "isPush",
                key: "isPush",
                align: "center",
                scopedSlots: { customRender: "isPush" },
              },
              {
                title: "是否发布",
                dataIndex: "isOpen",
                key: "isOpen",
                align: "center",
                scopedSlots: { customRender: "mark" },
              },
              {
                title: "操作",
                width: "200",
                scopedSlots: { customRender: "operate" },
              },
            ],
        }
    },
    components: {
      Editor,
      Toolbar,
    },
    created() {
      this.getTable();
      this.GetXXLX()
    },
    methods: {
      onCreated(editor) {
        this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
      },
      // 删除
      async delBtn(id) {
        const response = await delMessage(id);
        if (response.code == 0) {
          this.getTable();
          this.$message.success("删除成功");
        } else {
          this.$message.warning(response.message);
        }
      },
      async getDetails() {
        let data = {
          pushMessageId:this.pushMessageId,
          pageNo:this.pagiDnation.current,
          pageSize:this.pagiDnation.pageSize
        }
        const response = await getReceive(data);
        if (response.code == 0) {
          // this.getTable();
          // this.$message.success("删除成功");
          // console.log("明细",response.data)
          this.PushTable = response.data
          this.pagiDnation.total = response.count
        } else {
          this.$message.warning(response.message);
        }
      },
      async openPush(item){
        this.PushShow = true
        // console.log("明细",item)
        this.pushMessageId = item.id
        this.pagiDnation.current = 1
        this.pagiDnation.pageSize = 10
        this.getDetails()
      },
      PushCancel(){
        this.PushShow = false
      },
      // 置顶按钮开关
      async openChange(record, isPush) {
        var data = {};
        data = record;
        // data.id = record.id
        data.isPush = isPush;
  
        const Info = await putMessage(data);
        if (Info.code === 0) {
          this.getTable();
          this.$message.success("操作成功");
        } else {
          this.$message.error("操作失败" + Info.message);
        }
      },
      async open2Change(record, isOpen) {
        var data = {};
        data = record;
        // data.id = record.id
        data.isOpen = isOpen;
  
        const Info = await putMessage(data);
        if (Info.code === 0) {
          this.getTable();
          this.$message.success("操作成功");
        } else {
          this.$message.error("操作失败" + Info.message);
        }
      },
      viewImage(item){
        // this.$refs.preview.show()
        this.modalOpen = true
        this.thisContent = item.content
      },
      editBtn(item){
        // console.log("item",item)
        this.html = "";
         this.onCreated();
         setTimeout(() => {
           this.html = item.content;
         }, 100);
        this.addForm = JSON.parse(JSON.stringify(item))
        this.addShow = true
        // this.btnContentType = 'edit'
        // this.btnType = 'edit'
      },
      noticeEdit(open){
        this.addForm.isSuportLink = open
      },
      // 新建
      async addOk() {
        // 判断推送范围是否填写完整
        if(this.addForm.channels.includes('mina') && this.addForm.isSuportLink == 1){
          if(this.addForm.minaLink == '' || this.addForm.minaLink == undefined){
            this.$message.error("请输入小程序跳转地址");
            return
          }
        }
        if(this.addForm.channels.includes('app')  && this.addForm.isSuportLink == 1){
          if(this.addForm.appLink == '' || this.addForm.appLink == undefined){
            this.$message.error("请输入app跳转地址");
            return
          }
        }
        if(this.addForm.channels.includes('web')  && this.addForm.isSuportLink == 1){
          if(this.addForm.webLink == '' || this.addForm.webLink == undefined){
            this.$message.error("请输入官网跳转地址");
            return
          }
        }
        this.$refs.add.validate(async (valid) => {
          // 表单校验
          if (valid) {
            if(this.addForm.type === 'text'){
              this.addForm.content = this.html;
            }
            if(this.addForm.content == '<p><br></p>' || this.addForm.content == undefined){
              this.$message.error("请填写完整文本/图片");
              return
            }
            if(this.addForm.id){  //编辑
              const response = await putMessage(this.addForm);
              if (response.code === 0) {
                // 刷新首页数据
                this.getTable();
                this.$message.success("修改成功");
                this.addShow = false;
              } else {
                this.$message.error(response.message);
              }
            }else{
              const response = await postMessage(this.addForm);
              if (response.code === 0) {
                // 刷新首页数据
                this.getTable();
                this.$message.success("新增成功");
                this.addShow = false;
              } else {
                this.$message.error(response.message);
              }
            }
            // console.log("表单",this.addForm)
            this.$refs.add.resetFields();
            this.addForm = {channels:[],isSuportLink:0}
            this.html = ''
          } else {
            this.$message.error("请填写完整");
          }
        });
      },
      // 下拉框接口（薪资）
      async GetXXLX() {
        const response = await getSelect("XXLX");
        if (response.code === 0) {
          this.messageType = response.data.value
        } else {
          this.$message.warning(response.message);
        }
      },
      selectBtn(){
        this.pagination.pageSize = 10
        this.pagination.pageNum = 1
        this.pagination.current = 1
        this.getTable()
      },
      restBtn(){
        this.pagination.pageSize = 10
        this.pagination.pageNum = 1
        this.pagination.current = 1 
        this.searchName = ''
        this.selectType = ''
        this.Ftype = ''
        this.FLType = ''
        this.getTable()
      },
      searchOk(){
        this.getTable()
      },
      async manageUploadIcon() {
        let inputDOM = this.$refs.manageIcon.files[0];
        // const image = await update_New(inputDOM);
        const image = await update_New("other", inputDOM);
        if (image.code === 0) {
          this.$set(this.addForm, "content", image.data.url);
          this.$message.success("上传成功");
          document.getElementById("manageLibrary").value = null;
          // this.$refs.manageItem.clearValidate("manageIcon");
        } else {
          this.$message.warning("上传失败" + image.message);
        }
      },
      onChange(checkedValues) {
        // console.log('checked = ', this.addForm.channels);
      },
      typeChange(value) {
        // this.degree = value
        // // // 重置页码和分页数 以及current
        // this.pagination.pageSize = 10
        // this.pagination.pageNum = 1
        // this.pagination.current = 1
  
        this.getTable()
        // // // console.log(this.stateType)
        // this.getFeedback()
       
        // console.log(value)
    },
      //上传图片
      async uploadImg(type) {
        var inputTest = document.querySelector('#inputTest')
        let inputDOM = this.$refs[type].files[0];
        // console.log(this.$refs[type])
        if(inputDOM.size < 512000 ){
          const image = await update(inputDOM)
          if (image.code === 0){
             this.form.images = (image.data.url)
          }
        }
        else{
          this.$message.warning('仅上传500k内图片')
        }
        inputTest.value =''
      },
      // 分页查询
      pageChange(page_no, page_size) {
        this.pagination.pageNum = page_no;
        this.pagination.pageSize = page_size;
        this.getTable();
      },
      // 搜索框查询
      searchBtn() {
        // 重置页码
        this.pagination.pageNum = 1;
        this.pagination.pageSize = 10;
        this.pagination.current = 1;
        this.getTable();
      },
      // 新建表单
      newlyBuilt() {
        this.addShow = true;
        // this.addForm.drugOverview = "";
        // this.addForm.drugName = "";
        this.buttonType = "newBuild";
      },
      // table列表
      async getTable() {
        let data = {
          pageNo:this.pagination.current,
          pageSize:this.pagination.pageSize,
          title:this.searchName,
          type:this.selectType,
          channel:this.Ftype,
          messageType:this.FLType
        }
        const response = await getMessage(data);
        if (response.code === 0) {
          this.HeplTable = response.data;
          this.pagination.total = response.count;
          // console.log("表", this.HeplTable);
        } else {
          this.$message.warning(response.message);
        }
      },
      // 弹窗取消
      addCancel() {
        // this.$refs.add.resetFields();
        this.$refs.add.clearValidate();
        this.addShow = false;
        this.addForm = {channels:[],isSuportLink:0}
        // this.btnContentType = "save";
        // this.btnType = "save";
      },
    },
}
</script>

<style lang="scss" scoped>
.datePicker {
  background-color: #fff;
  width: 100%;
  height: 64px;
  padding: 20px;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  position: relative;

  .status {
    float: right;
    position: absolute;
    right: 50px;
  }
}
.uploadImg{
  width: 100%;
  border: #DDDDDD 2px dashed;
  width: 120px;
  height: 120px;
//   background-image: url("../../assets/add.png");
  background-size:100% 100%;
  background-repeat:no-repeat;
  cursor: pointer;
  margin-right: 11px;

  /* 需要撤回就删 */
  float: left;   
  display: inline-block;
}

.uploadImgVideo{
  border: #DDDDDD 2px dashed;
  width: 120px;
  height: 120px;
//   background-image: url("../../assets/add.png");
  background-size:100% 100%;
  background-repeat:no-repeat;
  cursor: pointer;
    float: left;  
    margin-right: 12px;
}

::v-deep .ant-table-thead > tr > th {
  font-weight: bold;
}

.uploadImg2{
  width: 330px;
  height: 190px;
  border: 1px dashed #ccc;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  font-size: 50px;
}
.multi-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; // 超出一行则以...形式隐藏
  -webkit-box-orient: vertical;
  cursor: pointer;
  // background-color: green;
}
</style>